export default __webpack_public_path__ + "static/media/car.298d97bd.svg";